module.exports = __webpack_public_path__ + "static/media/TDSAT_Logo_Golden.a7370e5b.svg";